import React from 'react';

const Tag = ({ label }) => {
    return (
        <>
            <div className='item-tag'>
                <span className='tag-text'>{label}</span>
            </div>
        </>
    );
};

export default Tag;
